const locale = require('./accountGrid.i18n.json');

/*@ngInject*/
const AccountGridController = function ($scope, $controller, $timeout, advancedFilterType, appTypeConfigurationModel, coreConstant, coreMediator, landingConstant, submissionGridConstant, gridColumnModel, persistentConnection, preferenceModel, submissionConstant, xmlUtil) {

    angular.extend(this, $controller('baseGridWidgetController', {$scope: $scope}));

    let timeoutList = [];

    this.i18n = locale;

    this.isColumnFilterVisible = true;
    this.isGridFilterVisible = true;
    this.isViewActiveVisible = true;
    this.isSearchVisible = true;
    this.isGridPagingVisible = true;
    this.filterParams = {};
    this.advancedFilterType = advancedFilterType.ACCOUNT_GRID;

    this.$onInit = function () {
        this.columnPreference = 'system.assignAccountSearchColumns';
        this.openDetailDrawerEvent = submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER;
        this.closeDetailDrawerEvent = submissionGridConstant.event.CLOSE_SUBMISSION_DETAIL_DRAWER;
        this.requestParams = this.getFilterParams();

        this.onInitGridWidget();
    };

    this.updateFilterFromPreferences = function () {
        $scope.$broadcast(submissionGridConstant.event.RESET_GRID_LIST);
    };

    this.loadRecords = function (onSuccess, onError) {
        if (!_.isNil(this.accounts)) {
            onSuccess(this.accounts);
            this.isLoading = false;
            this.isLoaded = true;
        }
    };

    this.generateColumns = function () {
        this.colViewModel = xmlUtil.parseString(preferenceModel.get(this.columnPreference));
        this.isGridPagingVisible = false;
    };

    this.resetParams = function (requestParams) {
        this.requestParams = requestParams;
    };

    this.getValue = function (item, column) {
        let value;
        if (column._accessor === 'identifiers') {
            value = _.findLast(item.identifiers, ['type', column.__text]);
            if (!_.isNil(value)) {
                return value.identifier;
            }
        } else if (column._accessor === 'aliases') {
            return _.join(_.map(item.aliases, 'name'), ', ');
        } else if (_.isNil(item[column._accessor])) {
            value = _.findLast(item.dynamaccountcDisplayData, ['name', column.__text]);
            if (!_.isNil(value)) {
                return value.identifier;
            }
        } else {
            return item[column._accessor];
        }
    };

    this.setFilterParams = function () {

    };

    this.getFilterParams = function () {
        return this.filterParams;
    };

    this.setSelectedItem = function (event, selectedItem) {
        if (selectedItem.selected) {
            selectedItem.selected = false;
            this.isDrawerOpen = false;
            $scope.$emit(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER, null);
            return;
        } else {
            this.isDrawerOpen = true;
        }
        _.forEach(this.records, function (item) {
            item.selected = (item === selectedItem);
        });
        $scope.$emit(submissionGridConstant.event.OPEN_SUBMISSION_DETAIL_DRAWER, selectedItem.id, selectedItem.accountNumber);
    };

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    $scope.$on(submissionGridConstant.event.RESET_GRID_COLUMNS, function () {
        this.updateColumnsFromPreferences();
        this.resetGridColumns();
    }.bind(this));

    $scope.$on(submissionGridConstant.event.RESET_GRID_LIST, function () {
        this.loadListOnFilterChange();
    }.bind(this));

    $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, params) {
        this.resetParams(params);
        if (this.isLoaded) {
            this.loadGrid();
        }
    }.bind(this));

    $scope.$on(coreConstant.event.USERTYPE_UPDATED, function () {
        persistentConnection.connect().then(function () {
            this.isUserTypeUpdated = true;
            this.isAgent = appTypeConfigurationModel.isAgentConsole();
            this.initLandingPage();
        }.bind(this));
    }.bind(this));

    $scope.$on(coreConstant.event.FILTER_SAVED, this.handleFilterSave.bind(this));
};

angular.module('gw-um-submission')
    .controller('accountGridController', AccountGridController);
